/**
 * Le mot qu'un écran met sur un refus de connecteur.
 *
 * Deux écrans l'affichent — la pastille « État » de la liste des Connecteurs et le badge du
 * tableau Plateformes de l'accueil — et ils parlaient déjà de deux façons du même fait : la
 * liste disait « Actif » pendant que l'accueil disait « Token expiré », pour un compte Awin dont
 * la clé était refusée depuis trois semaines. La règle vit donc ici, et nulle part ailleurs.
 *
 * ⚠️ **« Refusé » et « expiré » ne sont pas deux façons de dire la même chose**, et c'est tout
 * l'objet de ce module. Un jeton Awin n'a **aucune durée de vie** : annoncer « expiré » envoie
 * chercher une date d'expiration qui n'existe pas, et fait conclure à une panne passagère là où
 * la clé a été régénérée ou révoquée. C'est la même discipline que `verdictMesureMeta`, qui
 * sépare l'habilitation retirée du jeton périmé parce que les deux appellent deux gestes
 * différents — ici, recoller une clé plutôt qu'attendre ou se reconnecter.
 *
 * ⚠️ **L'ordre des tests est porteur.** « Accès refusé » contient le mot « refus » : chercher
 * « refus » pour la clé rangerait une permission manquante sous « Clé refusée ». On n'interroge
 * donc que les mots qui ne désignent qu'elle — invalide, révoqué, illisible, `invalid_token` —
 * et la branche de l'expiration reste **après**, son « token » ramassant sinon tout le reste.
 */
export function libelleRefusConnecteur(message) {
  const texte = String(message || '').toLowerCase();

  if (
    texte.includes('invalide')
    || texte.includes('révoqu')
    || texte.includes('revoqu')
    || texte.includes('illisible')
    || texte.includes('invalid_token')
    || texte.includes('invalid token')
  ) return 'Clé refusée';

  if (texte.includes('absente') || texte.includes('absent')) return 'Clé absente';
  if (texte.includes('token') || texte.includes('expir')) return 'Token expiré';
  if (texte.includes('permission') || texte.includes('accès') || texte.includes('access')) return 'Accès refusé';
  return 'Erreur';
}

export default libelleRefusConnecteur;
